/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import { useDispatch, useSelector } from 'react-redux'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { showModal, fetchPolicies } from '../../../../../../redux/actions'
import { hasPolicy } from '../../../../../../redux/modules/authentication/authentication'
import { IS_PARTNER } from '../../../../../../auth/policies'
import DialogSubsectionHeadline from '../../../../../Header/DialogSubsectionHeadline'

const useStyles = createUseStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
})

export function ApiSection({ listing }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const isPartner = useSelector(hasPolicy(IS_PARTNER))

  useEffect(() => {
    dispatch(fetchPolicies([IS_PARTNER]))
  }, [dispatch])

  const createNewBearer = () => dispatch(showModal('SHOW_BEARER', { listing }))
  const createNewRedemptionToken = () => dispatch(showModal('SHOW_REDEMPTION_TOKEN', { listing }))

  return (
    <div>
      <div>
        <DialogSubsectionHeadline>Bearer Token</DialogSubsectionHeadline>
      </div>
      <div>
        <div className={classes.header}>
          <Typography style={{ margin: '10px 0px' }}>
            <Button variant="contained" color="primary" style={{ textTransform: 'none' }} onClick={createNewBearer}>
              Create New Bearer
            </Button>
          </Typography>
        </div>
      </div>
      {isPartner && (
        <>
          <div>
            <DialogSubsectionHeadline>Redemption API Bearer Token</DialogSubsectionHeadline>
          </div>
          <div>
            <div className={classes.header}>
              <Typography style={{ margin: '10px 0px' }}>
                <Button variant="contained" color="primary" style={{ textTransform: 'none' }} onClick={createNewRedemptionToken}>
                  Create Redemption Token
                </Button>
              </Typography>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default ApiSection
